import React from "react";

import loadable from "@loadable/component";

const Usercomponent = loadable(
  () => import("../../components/Customer/Customer")
);

const CustomerList = () => {
  return (
    <div>
      <Usercomponent />
    </div>
  );
};

export default CustomerList;

